import RomeDomain from '@enterprise/models/dto/rome-domain.response.dto';
import UpdateRomeDomainOrderDto from '@models/dto/update-rome-domain-order.dto';
import IPaginatedesponse from '@models/paginated-reponse';
import { reorderRomeDomains } from '@services/romeDomainService';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useRomeDomainsOrderMutation = () => {
  const romeDomainsOrderMutations = useMutation<
    AxiosResponse<IPaginatedesponse<RomeDomain>>,
    unknown,
    UpdateRomeDomainOrderDto[],
    unknown
  >((mutationVariables) => reorderRomeDomains(mutationVariables), {});

  return romeDomainsOrderMutations;
};
